module.exports = __webpack_public_path__ + "static/media/TROPHEE.a6588dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/TROPHEE.png
// module id = 290
// module chunks = 0